module.exports = __webpack_public_path__ + "media/images/vector-135@2x-b8837f6c70f653095f6074cba3a6f27f.png";